import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import AdminLayout from "../../../components/admin/common/AdminLayout";
import EditQuestionForm from "../../../components/admin/question/EditQuestionForm";
import { clearQuestion, getQuestion } from "../../../redux/slice/questionSlice";
import { fetchTopics, getTopics } from "../../../redux/slice/topicSlice";

const EditQuestion = () => {
  const id = useParams().id;
  const dispatch = useDispatch();
  const topics = useSelector(getTopics);

  useEffect(() => {
    dispatch(getQuestion(id));
    if (!topics) {
      dispatch(fetchTopics());
    }
    return () => {
      dispatch(clearQuestion());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);

  return (
    <>
      <AdminLayout>
        <EditQuestionForm />
      </AdminLayout>
    </>
  );
};

export default EditQuestion;
